import { Toaster as SonnerToaster } from "sonner";
import { useTheme } from "../../lib/theme";

export const Toaster = () => {
  const { resolved } = useTheme();
  return (
    <SonnerToaster
      theme={resolved}
      position="bottom-right"
      richColors
      closeButton
      duration={4000}
      toastOptions={{
        classNames: {
          toast: "font-sans",
        },
      }}
    />
  );
};
